/* eslint-disable */
import FreeCancellationAbstract from '@/js/common/components/freeCancellation';
import {propsDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import template from './template.html';

import './style.scss';

@propsDecorator({
	template: template
})
export default class FreeCancellationSignDesktop extends FreeCancellationAbstract {}